import React from 'react';

import { Flex, Paragraph } from '@vimeo/bokeh';
import { Comment } from '@vimeo/bokeh-icons';
import { IBaseDomElementProps } from '@vimeo/core/types/dom';

import { createInteractionDomName } from '../../../../../libs/shared/utils/dom/identifying';
import { IconCircle } from '../../../shared/IconCircle';
import { PAGE_WRAPPER_STYLE } from '../styles';
import {
  LOGIN_CONTAINER_WRAPPER_STYLE,
  LOGIN_CONTEXT_LABELS_STYLE,
  LOGIN_SCREEN_WRAPPER_STYLE,
} from './styles';

interface IInteractionNoAccessLayoutProps extends IBaseDomElementProps {
  isWithIcon?: boolean;
  reason: string;
}

/**
 * Display access blocked with simple reason label.
 */
export function InteractionNoAccessLayout({
  id = createInteractionDomName('interaction-no-access'),
  isWithIcon,
  reason,
}: IInteractionNoAccessLayoutProps) {
  return (
    <Flex id={id} sx={PAGE_WRAPPER_STYLE}>
      <Flex id={createInteractionDomName(id, 'content')} sx={LOGIN_SCREEN_WRAPPER_STYLE}>
        <Flex id={createInteractionDomName(id, 'form')} sx={LOGIN_CONTAINER_WRAPPER_STYLE}>
          <Flex sx={LOGIN_CONTEXT_LABELS_STYLE}>
            {isWithIcon ? (
              <IconCircle id={createInteractionDomName(id, 'icon')}>
                <Comment boxSize={'sm'} />
              </IconCircle>
            ) : null}
            <Paragraph size={'lg'} textAlign={'center'} color={'text-secondary'}>
              {reason}
            </Paragraph>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}
